// extracted by mini-css-extract-plugin
export default {"container_gender":"gender_container_gender__yMkkj","image_gender":"gender_image_gender__aha0u","gender_text":"gender_gender_text__7-5oC"};